import { render, staticRenderFns } from "./FooterUsers.vue?vue&type=template&id=6bd25fe7&scoped=true&"
import script from "./FooterUsers.vue?vue&type=script&lang=ts&"
export * from "./FooterUsers.vue?vue&type=script&lang=ts&"
import style0 from "./FooterUsers.vue?vue&type=style&index=0&id=6bd25fe7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd25fe7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VSpacer})
